import Actions from '../actions'
import { customNavWrapper } from '../utils/notificationMapper'
import {
  markNotificationAsSeen,
  sendNotificationAnalytics,
} from './notificationLinksNavHelper'

const parseNotification =
  dispatch =>
  (navigations, details, notificationId, notificationSeen, title, isPinned) => {
    let action = null
    switch (navigations?.type) {
      case 'link': {
        action = () => {
          dispatch(
            Actions.createAction(
              Actions.NAVIGATED_TO,
              navigations?.sow_screen_name
            )
          )
          if (!isPinned) {
            markNotificationAsSeen(dispatch, notificationId, notificationSeen)
          }
          sendNotificationAnalytics(
            dispatch,
            navigations,
            details,
            notificationId,
            notificationSeen,
            title
          )
        }
        break
      }
      case 'external_link': {
        action = () => {
          markNotificationAsSeen(dispatch, notificationId, notificationSeen)
          sendNotificationAnalytics(
            dispatch,
            navigations,
            details,
            notificationId,
            notificationSeen,
            title
          )
          window.location.href = navigations?.href
        }
        break
      }
      case 'custom': {
        action = () => {
          customNavWrapper(
            dispatch,
            navigations,
            notificationId,
            notificationSeen
          )
          sendNotificationAnalytics(
            dispatch,
            navigations,
            details,
            notificationId,
            notificationSeen,
            title
          )
        }
        break
      }
      default: {
        break
      }
    }
    return { text: details, action }
  }

export const formatNotification =
  dispatch =>
  (navigations, details, notificationId, notificationSeen, title, isPinned) => {
    return parseNotification(dispatch)(
      navigations,
      details,
      notificationId,
      notificationSeen,
      title,
      isPinned
    )
  }
